import React, {useEffect, useRef} from 'react'
import {Col, Row} from 'components/Display'
import ChatMessage from 'components/ChatMessage'
import services from 'services'
import Spinner from 'components/Spinner'

type ProblemCommentsProps = {
  threadId: string
  header: React.ReactNode
}

export default function CommentSection(props: ProblemCommentsProps) {
  const service = services.getChatService(props.threadId)
  const [messages, isLoadingMessages] = service.messages.hook()

  // Handles scrolling to bottom when a new chat message is added
  const messagesEndRef = useRef<HTMLDivElement>(null)
  const scrollToBottom = () => {
    if (null !== messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({behavior: 'smooth'})
    }
  }

  useEffect(scrollToBottom, [messages])

  return (
    <Col className="py-6">
      {props.header}
      {isLoadingMessages && (
        <Row className="justify-center items-center">
          <Spinner />
        </Row>
      )}
      {!isLoadingMessages && (
        <div>
          {messages.map((msg, index) => (
            <div key={msg.id} className="px-8 mt-4">
              <ChatMessage message={msg} />
            </div>
          ))}
        </div>
      )}
      {!isLoadingMessages && <div ref={messagesEndRef} className="py"></div>}
    </Col>
  )
}
